import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d69b545"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "app-header",
  class: "navbar",
  role: "navigation",
  "aria-label": "Main navigation"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#skip-to-main-content",
  class: "skip-link t--white t--uppercase t--bold t--caption"
}, " Skip to main content ", -1))
const _hoisted_3 = { class: "navbar-container" }
const _hoisted_4 = { class: "navbar-brand" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/name-and-badge.svg",
  id: "name-and-badge-png",
  alt: "CivicPlus NextRequest"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  class: "navbar-menu",
  ref: "menu"
}
const _hoisted_12 = { class: "navbar-start" }
const _hoisted_13 = ["href", "onClick"]
const _hoisted_14 = ["href", "onClick"]
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "navbar-end" }
const _hoisted_18 = {
  key: 0,
  class: "navbar-item has-dropdown is-hoverable",
  "data-link": "nr-internal"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<span class=\"navbar-link\" data-v-2d69b545>NR Internal</span><div class=\"navbar-dropdown is-right is-boxed\" data-v-2d69b545><a href=\"/stats\" class=\"navbar-item\" data-v-2d69b545>Stats</a><a href=\"/internal/accounts\" class=\"navbar-item\" data-v-2d69b545>Customers</a><a href=\"/internal/users\" class=\"navbar-item\" data-v-2d69b545>Users</a></div>", 2)
const _hoisted_21 = [
  _hoisted_19
]
const _hoisted_22 = {
  key: 1,
  class: "navbar-item has-dropdown is-hoverable",
  "data-link": "admin"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-link" }, "Admin", -1))
const _hoisted_24 = { class: "navbar-dropdown is-right is-boxed" }
const _hoisted_25 = {
  key: 0,
  href: "/admin",
  class: "navbar-item"
}
const _hoisted_26 = {
  key: 0,
  href: "/admin/document_dashboard",
  class: "navbar-item"
}
const _hoisted_27 = /*#__PURE__*/_createStaticVNode("<a href=\"/reports\" class=\"navbar-item\" data-v-2d69b545>Reports</a><hr class=\"navbar-divider\" data-v-2d69b545><a href=\"/admin/departments\" class=\"navbar-item\" data-v-2d69b545>Departments</a><a href=\"/admin/users\" class=\"navbar-item\" data-v-2d69b545>Users</a><a href=\"/admin/request_text_filters\" class=\"navbar-item\" data-v-2d69b545> Alerts </a><a href=\"/admin/tags\" class=\"navbar-item\" data-v-2d69b545>Tags</a>", 6)
const _hoisted_33 = {
  key: 3,
  href: "/admin/onboarding",
  class: "navbar-item"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/admin/redaction_reasons",
  class: "navbar-item"
}, " Redaction reasons ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/admin/redaction_regexes",
  class: "navbar-item"
}, " Redaction patterns ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/admin/message_templates",
  class: "navbar-item"
}, " Message templates ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/admin/close_request_types",
  class: "navbar-item"
}, " Closure templates ", -1))
const _hoisted_40 = {
  key: 5,
  href: "/admin/invoice_templates",
  class: "navbar-item"
}
const _hoisted_41 = {
  key: 6,
  href: "/admin/invoice_charges",
  class: "navbar-item"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1))
const _hoisted_43 = ["href"]
const _hoisted_44 = {
  class: "navbar-item has-dropdown is-hoverable",
  "data-link": "profile"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-link" }, "Signed in", -1))
const _hoisted_46 = { class: "navbar-dropdown is-right is-boxed" }
const _hoisted_47 = { class: "navbar-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "navbar-divider" }, null, -1))
const _hoisted_49 = ["href"]
const _hoisted_50 = {
  key: 2,
  class: "navbar-item"
}
const _hoisted_51 = {
  key: 0,
  action: "/users/auth/openid_connect",
  method: "post"
}
const _hoisted_52 = ["name", "value"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "Submit",
  class: "button is-primary",
  value: "Sign in"
}, null, -1))
const _hoisted_54 = {
  key: 1,
  href: "/users/sign_in",
  class: "button is-primary",
  "data-link": "sign-in"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select a user to impersonate", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " By selecting this user, you can preview what the application looks like as this user, including which controls and content they can access. You can only select other users who have lower level permission roles in the application. Any action taken during the preview will still be attributed to your user account. ", -1))
const _hoisted_57 = {
  key: 0,
  class: "preview-banner"
}
const _hoisted_58 = { class: "preview-banner-title" }
const _hoisted_59 = { class: "has-text-weight-semibold" }
const _hoisted_60 = { class: "preview-banner-switch-container" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You have been logged out due to inactivity. Use the button below to sign back into the application ", -1))
const _hoisted_62 = {
  key: 1,
  ref: "signInForm",
  action: "/users/auth/openid_connect",
  method: "post",
  class: "openid-form"
}
const _hoisted_63 = ["name", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GlobalFullTextSearch = _resolveComponent("GlobalFullTextSearch")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrModal = _resolveComponent("NrModal")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrButton = _resolveComponent("NrButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: "/",
              class: "navbar-title navbar-item is-5 t--title-secondary",
              title: $options.accountName
            }, _toDisplayString($options.accountName), 9, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("a", {
            href: "#",
            role: "button",
            class: "navbar-burger",
            "aria-label": "menu",
            "aria-expanded": "false",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleToggleMenu && $options.handleToggleMenu(...args)), ["stop"]))
          }, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/requests/new",
                  custom: ""
                }, {
                  default: _withCtx(({ href, route, navigate }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass($options.getNavbarItemClassName(route))
                    }, [
                      _createElementVNode("a", {
                        href: href,
                        onClick: ($event: any) => ($options.handleNavigate($event, navigate))
                      }, " Make request ", 8, _hoisted_13)
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/requests",
                  custom: ""
                }, {
                  default: _withCtx(({ href, route, navigate }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass($options.getNavbarItemClassName(route))
                    }, [
                      _createElementVNode("a", {
                        href: href,
                        onClick: ($event: any) => ($options.handleNavigate($event, navigate))
                      }, " All requests ", 8, _hoisted_14)
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/documents",
                  custom: ""
                }, {
                  default: _withCtx(({ href, route, navigate }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass($options.getNavbarItemClassName(route))
                    }, [
                      _createElementVNode("a", {
                        href: href,
                        onClick: ($event: any) => ($options.handleNavigate($event, navigate))
                      }, " Documents ", 8, _hoisted_15)
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                ($props.canReadStaffOnly)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/tasks",
                      custom: ""
                    }, {
                      default: _withCtx(({ href, route }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass($options.getNavbarItemClassName(route))
                        }, [
                          _createElementVNode("a", { href: href }, " All tasks ", 8, _hoisted_16)
                        ], 2)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            ($options.hasFullTextFeature)
              ? (_openBlock(), _createBlock(_component_GlobalFullTextSearch, {
                  key: 0,
                  class: "navbar-item search-field-on-navbar"
                }))
              : _createCommentVNode("", true),
            ($options.isAuthenticated)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  ($props.canManageInternalAdminTools)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                    : _createCommentVNode("", true),
                  ($props.canReadAdminOnly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          ($props.canManageAll)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_25, "Admin dashboard"))
                            : _createCommentVNode("", true),
                          ($options.isSpa)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                ($props.canManageAll)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: "/admin/document_dashboard",
                                      class: "navbar-item"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Document dashboard ")
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                ($props.canManageAll)
                                  ? (_openBlock(), _createElementBlock("a", _hoisted_26, " Document dashboard "))
                                  : _createCommentVNode("", true)
                              ], 64)),
                          _hoisted_27,
                          ($props.account.uploaders_feature_flag)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_33, " Upload users "))
                            : _createCommentVNode("", true),
                          ($props.account.redaction || $props.account.document_review)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _hoisted_34,
                                _hoisted_35,
                                _hoisted_36
                              ], 64))
                            : _createCommentVNode("", true),
                          _hoisted_37,
                          _hoisted_38,
                          _hoisted_39,
                          ($props.account.payments)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_40, " Invoice templates "))
                            : _createCommentVNode("", true),
                          ($props.account.payments)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_41, " Invoice charges "))
                            : _createCommentVNode("", true),
                          ($props.canManageAll)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                _hoisted_42,
                                _createElementVNode("a", {
                                  href: $options.accountSettingsPath,
                                  class: "navbar-item"
                                }, " Portal settings ", 8, _hoisted_43)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("p", null, [
                          _createTextVNode(" Signed in as "),
                          _createElementVNode("strong", null, _toDisplayString($props.user.email_or_name), 1)
                        ])
                      ]),
                      _hoisted_48,
                      (!$props.permissionsPreviewUser)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: $options.userSettingsPath,
                            class: "navbar-item"
                          }, "My settings", 8, _hoisted_49))
                        : _createCommentVNode("", true),
                      ($props.canPreviewUser)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.setPermissionModal && $options.setPermissionModal(...args))),
                            class: "navbar-item"
                          }, " Permission preview "))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", {
                        href: "/users/sign_out",
                        class: "navbar-item",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.handleSignoutClick && $options.handleSignoutClick(...args)), ["prevent","stop"]))
                      }, " Sign out ")
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  ($options.hasCivicplusSSOFeature)
                    ? (_openBlock(), _createElementBlock("form", _hoisted_51, [
                        _createElementVNode("input", {
                          name: $options.csrfParam,
                          value: $data.csrfToken,
                          type: "hidden"
                        }, null, 8, _hoisted_52),
                        _hoisted_53
                      ]))
                    : (_openBlock(), _createElementBlock("a", _hoisted_54, " Sign in "))
                ]))
          ])
        ], 512)
      ]),
      ($options.hasFullTextFeature)
        ? (_openBlock(), _createBlock(_component_GlobalFullTextSearch, {
            key: 0,
            class: "search-field-below-navbar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_NrModal, {
        class: _normalizeClass(`permission-modal ${!$options.isSpa ? 'legacy-permission-modal' : ''}`),
        primaryButtonText: "Set permissions",
        secondaryButtonText: "Cancel",
        title: "Set permission view",
        hasSecondaryButton: true,
        show: $data.permissionModal,
        onOnPrimaryClick: $options.submitPermission,
        onOnSecondaryClick: $options.resetPreviewModal,
        onOnCloseClick: $options.resetPreviewModal
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NrSelect, {
            modelValue: $data.selectedPreviewUsers,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.selectedPreviewUsers) = $event)),
            options: $data.filteredPreviewUsers,
            onOpen: $options.searchPreviewUsers,
            onSearch: $options.searchPreviewUsers,
            filterable: false,
            loading: $data.previewFetchState.fetching,
            hasMore: !$data.previewFetchState.end,
            onLoadMore: $options.loadMorePreviewUsers
          }, {
            label: _withCtx(() => [
              _hoisted_55
            ]),
            _: 1
          }, 8, ["modelValue", "options", "onOpen", "onSearch", "loading", "hasMore", "onLoadMore"]),
          _hoisted_56
        ]),
        _: 1
      }, 8, ["class", "show", "onOnPrimaryClick", "onOnSecondaryClick", "onOnCloseClick"])
    ]),
    ($props.permissionsPreviewUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_component_NrTooltip, { label: `By selecting this user, you can preview what the application looks like as this user, including which controls and content they can access. You can only select other users who have lower level permission roles in the application. Any action taken during the preview will still be attributed to your user account.` }, {
              default: _withCtx(() => [
                _createVNode(_component_NrIcon, {
                  class: "m-right-8 m-left-8 m-bottom-4 inline-icon",
                  name: "info-circle"
                }),
                _createElementVNode("span", _hoisted_59, " Permission view on: viewing portal as \"" + _toDisplayString($props.permissionsPreviewUser) + "\" ", 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_component_NrButton, { onClick: $options.submitPermission }, {
              default: _withCtx(() => [
                _createTextVNode(" Turn off permissions preview ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_NrModal, {
      primaryButtonText: "Sign in",
      title: "Session expired",
      size: "small",
      hasSecondaryButton: false,
      show: $data.sessionExpired,
      onOnPrimaryClick: $options.directToSignIn
    }, {
      default: _withCtx(() => [
        _hoisted_61
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"]),
    ($options.hasCivicplusSSOFeature)
      ? (_openBlock(), _createElementBlock("form", _hoisted_62, [
          _createElementVNode("input", {
            name: $options.csrfParam,
            value: $data.csrfToken,
            type: "hidden"
          }, null, 8, _hoisted_63)
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_NrModal, {
      class: "session-warning-modal",
      title: "Your session will expire soon",
      type: "warning",
      show: $data.showSessionWarningModal,
      primaryButtonText: "Yes, extend my expiration",
      secondaryButtonText: "Logout",
      size: "small",
      hasSecondaryButton: "",
      onOnPrimaryClick: $options.resetSessionTimeout,
      onOnSecondaryClick: $options.handleSignoutClick
    }, {
      default: _withCtx(() => [
        _createTextVNode("Your session will expire soon and you will be logged out automatically. Do you wish to extend your session? Your session will timeout in " + _toDisplayString($data.expirationInMinsAndSecs), 1)
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick", "onOnSecondaryClick"])
  ]))
}